module.exports = __webpack_public_path__ + "static/media/Map3.c7db5636.jpg";